import React from 'react';
import { Link, useMatch, useNavigate } from 'react-router-dom';
import './navitem.css'
import blob from './../../assets/Blob.png'

const Navitem = (props) => {
    const isActive = useMatch(props.link);
    const navigate = useNavigate();

    return (
        <li
            className={`${props.style1} ${isActive ? "active" : ""}`}
            tabIndex={0}
            role="none"
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(props.link);
                }
            }}
        >
            <img className='blob scaleIn' src={blob} alt="" />
            <Link
                to={props.link}
                id="link"
                aria-current={isActive ? "page" : undefined}
                aria-label={props.title}
                tabIndex={-1}
            />
            <img className='iconimg' alt="" src={props.icon} />
            {props.title}
        </li>
    );
}

export default Navitem;